(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  function initCollectionTabs() {
    document.querySelectorAll('[data-collection-tabs-root]').forEach((root) => {
      if (root.dataset.collectionTabsBound === 'true') return;
      root.dataset.collectionTabsBound = 'true';

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || !panels.length) return;

      const activate = (tab) => {
        const panelId = tab.getAttribute('aria-controls');
        const panel = panelId && root.querySelector('#' + CSS.escape(panelId));

        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach((p) => {
          if (p === panel) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (e) => {
          const i = tabs.indexOf(tab);
          let next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            next = tabs[(i + 1) % tabs.length];
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            next = tabs[(i - 1 + tabs.length) % tabs.length];
          } else if (e.key === 'Home') {
            e.preventDefault();
            next = tabs[0];
          } else if (e.key === 'End') {
            e.preventDefault();
            next = tabs[tabs.length - 1];
          }
          if (next) {
            next.focus();
            activate(next);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTabs);
  } else {
    initCollectionTabs();
  }
  document.addEventListener('shopify:section:load', initCollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
